import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-bi-reports',
  templateUrl: './bi-reports.component.html',
  styleUrls: ['./bi-reports.component.css']
})
export class BiReportsComponent implements OnInit {
    public itemsListBiReports: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadBiReports() {
        this.itemsListBiReports = await this.datatask.Post(2660);
    }

    private async init() {
        this.loadBiReports();
    }

    ngOnInit() {
        this.init();
    }
}
